import React from 'react';
import { FormGroup } from 'components/common/Forms';
import { compose } from 'recompose';
import DropZone from 'react-dropzone';
import { Row, Col } from 'reactstrap';

export const LogoUpload = ({
  item,
  logo,
  onFileDrop,
  renderServerError,
  readOnly,
}) => (
  <Row>
    <Col xs="12" sm="12" md="12" lg="4" xl="6">
      <FormGroup label="Logo">
        <br />
        <DropZone
          className="btn btn-primary logo-drop"
          accept="image/png, image/jpeg, image/gif"
          multiple={false}
          onDrop={onFileDrop}
          disabled={readOnly}
        >
          Drag and drop a Logo, or click here<br />
          PNG, JPG or GIF<br />
          {(logo || item.logo_image) && (
            <div
              style={{
                background: 'white',
                maxWidth: '100%',
                display: 'inline-block',
              }}
            >
              <img
                style={{ maxWidth: '100%', maxHeight: '30vh' }}
                src={(logo && logo.preview) || item.logo_image}
                alt="Installer Logo"
              />
            </div>
          )}
        </DropZone>
        {renderServerError('logo_image_file')}
      </FormGroup>
    </Col>
  </Row>
);

const enhance = compose();

export default enhance(LogoUpload);



// WEBPACK FOOTER //
// ./src/pages/Installers/LogoUpload.jsx